module.exports = __webpack_public_path__ + "static/media/30_VTA - Silicon Valley.cfb9bac7.jpg";